import { Label } from '@cian/ui-kit';

import { FC } from 'react';

export type AdLabelProps = {
  label: string;
};

export const AdLabel: FC<AdLabelProps> = ({ label }) => {
  return (
    <Label data-testid="label" background="overlay-default" color="text-inverted-default">
      {label}
    </Label>
  );
};
